import { Children, isValidElement, Fragment, createContext } from 'react';

export const TableContext = createContext({ labels: [] });

export const flattenChildren = children => Children.toArray(children).flatMap(child =>
  isValidElement(child) && child.type === Fragment ? flattenChildren(child.props.children) : [child]
);

export const contentText = node => {
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (isValidElement(node)) return contentText(node.props.children);
  return Children.toArray(node).map(contentText).join(' ').trim();
};